import axiosInstance from '../../../config/axiosInstance';
const  SupplierStockService = {
    async GetAllSupplierStocks(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/GetSupplierStock?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async SupplierStockCategory(redirectCallback,SupplierID) {
        try {            
           
         const response = await axiosInstance.get(`/Supplier/SupplierStockCategory?SupplierID=${SupplierID}`);
           return response.data;
        } catch (error) {
           
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSupplierStock(redirectCallback,ID) {
        try {            
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Supplier/DeleteSupplierStock?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default SupplierStockService;